// extracted by mini-css-extract-plugin
export default {"cardRoot":"styles_cardRoot__CIXkb","cardFooter":"styles_cardFooter__lvp4K"};